import React from 'react'
import { LessonList } from '../Lessons/LessonList'

const CoursesProfile = ({ studentId }) => {
	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<div className="card-header border-bottom">
				<h5 className="mb-0">Lessons</h5>
			</div>
			<div className="card-body p-0">
				<LessonList studentId={studentId} isStudent={true} isProfile={true} />
			</div>
		</div>
	)
}

export { CoursesProfile }
